import { SmartusComponentsModule } from '@affinis/smartus-components';
import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { OverrideModule } from '@override/override.module';
import { BreadcrumbService } from '@core/services/breadcrumb-service/BreadcrumbService';
import { CardConfig } from '@affinis/smartus-components/lib/card/card.component.types';
import { MaterialModule } from '@shared/material/material.module';
import { TelekomModule } from '@mandants/telekom/telekom.module';
import { TelekomSharedModule } from '@mandants/telekom/telekom-shared.module';
import { TelekomRemModule } from '../../rem/telekom-rem.module';

const DATE_FORMAT = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-exemption-submit',
  imports: [
    CommonModule,
    SmartusComponentsModule,
    TranslateModule,
    FormsModule,
    FormlyModule,
    OverrideModule,
    MaterialModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [provideMomentDateAdapter(DATE_FORMAT)],
  templateUrl: './exemption-submit.component.html',
  styleUrl: './exemption-submit.component.scss',
})
export class ExemptionSubmitComponent {
  card: CardConfig = {
    footer: {},
  };

  title = this.translateService.instant(
    'menu.tickets_tasks.component.exemption_submit'
  );

  constructor(
    private translateService: TranslateService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.setBreadcrumbs([{ label: this.title }]);
  }
}
